<template>
  <sec-section labelledby="about-who" :divider="false">
    <sec-split heading-id="about-who" :eyebrow="who.eyebrow" :title="who.title">
      <p class="m500 sec-body-lg" data-reveal>{{ who.text }}</p>
      <sec-pill-list :items="who.pills" />
    </sec-split>
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import SecSplit from '@/components/security/ui/SecSplit.vue';
import SecPillList from '@/components/security/ui/SecPillList.vue';
import { ABOUT } from '@/content/security/about';

const who = ABOUT.whoWeWorkWith;
</script>
